// The support-need write path's function references (bead hf-e4-events-needs-6r5.2).
//
// Everything the browser knows about the backend comes through
// `convex/_generated/api` — never a Convex module directly, which dependency-cruiser
// enforces. Return types are inferred from the generated types, so the browser
// cannot drift from what the functions actually return.

import type { FunctionReturnType } from "convex/server";

import { api } from "../../../../convex/_generated/api";
import type { Id } from "../../../../convex/_generated/dataModel";

export const needQueries = {
  get: api.domain.needs.getNeed,
  list: api.domain.needs.listNeeds,
  revisions: api.domain.needs.listNeedRevisions,
} as const;

export const needMutations = {
  create: api.domain.needs.createNeed,
  update: api.domain.needs.updateNeed,
  publish: api.domain.needs.publishNeed,
  complete: api.domain.needs.completeNeed,
  cancel: api.domain.needs.cancelNeed,
  deleteDraft: api.domain.needs.deleteDraftNeed,
} as const;

export type GetNeedResult = FunctionReturnType<typeof needQueries.get>;
export type ListNeedsResult = FunctionReturnType<typeof needQueries.list>;

/** Restore the generated Convex brand after an opaque need id crosses a route/read-model seam. */
export function needDocumentId(value: string): Id<"supportNeeds"> {
  return value as Id<"supportNeeds">;
}
